module.exports = __webpack_public_path__ + "img/tag_hand.cca33c07.svg";